import {
  Box,
  Center,
  Loader,
  LoaderProps,
  LoadingOverlay,
  Portal,
} from "@mantine/core";
import { ReactNode } from "react";
import classes from "./Loading.module.css";

type LoadingVariant = "inline" | "overlay" | "fullscreen";

interface LoadingProps {
  variant?: LoadingVariant;
  visible?: boolean;
  loaderProps?: LoaderProps;
  children?: ReactNode;
}

const Loading = ({
  variant = "inline",
  visible = true,
  loaderProps,
  children,
}: LoadingProps) => {
  if (variant === "fullscreen") {
    return (
      <>
        {children}
        {visible && (
          <Portal>
            <div className={classes.fullscreen}>
              <Loader {...loaderProps} />
            </div>
          </Portal>
        )}
      </>
    );
  }

  if (variant === "overlay") {
    return (
      <Box pos="relative">
        <LoadingOverlay
          visible={visible}
          overlayProps={{ backgroundOpacity: 0.4 }}
          loaderProps={loaderProps}
        />
        {children}
      </Box>
    );
  }

  if (!visible) return null;

  return (
    <Center className={classes.inline}>
      <Loader {...loaderProps} />
    </Center>
  );
};

export default Loading;
